import { render, staticRenderFns } from "./VideoGroupItem.vue?vue&type=template&id=7dad6b64&scoped=true&"
import script from "./VideoGroupItem.vue?vue&type=script&lang=js&"
export * from "./VideoGroupItem.vue?vue&type=script&lang=js&"
import style0 from "./VideoGroupItem.vue?vue&type=style&index=0&id=7dad6b64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dad6b64",
  null
  
)

export default component.exports